import * as React from "react"
import * as data from "./sitedata.json"
import { Blog } from "./blog"

export function Haiti() {

    return <div className=" max-w-4xl m-auto landing p-4 px-12 lg:px-none">
        <figure className=" shadow-lg mb-5 md:flex bg-slate-100 rounded-xl p-8 md:p-0 ">
            <div className="p-2 text-center md:text-left space-y-4">
                <blockquote>
                <img className="p-2 w-80 h-52  rounded-2xl float-left mr-3" src="/images/diapers.png" alt=""  />
                   <p className="text-2xl font-normal">
                        We make diapers out of t-shirts that go straight into the hands of Saint Teresa of Calcutta’s Missionaries of Charity Sisters.  There is a Missionaries of Charity Intermediate Care Center in Hinche, Haiti that intakes babies and children due to malnutrition, nourishes them back to health, and returns them to their homes. The facility is located in a tremendously impoverished area.  The Sisters work tirelessly to care for the children and the facility.  Their resources are limited, and their need for diapers is constant and great.  The diapers are washed by hand and hung out to dry.  While they are reusable, the washing process is hard on the fabric.
                    </p>
                </blockquote>
            </div>
        </figure>
        <div className=" h-[350px] flex  lg:flex-row lg:items-center lg:justify-between items-center">
            <div className="mb-4 w-full mr-2 lg:w-1/2 h-full ">
                <figure className=" h-full w-full  shadow-lg md:flex bg-slate-100 rounded-xl p-8 md:p-0 ">
                    <div className="p-2 pt-10 text-center md:text-left space-y-4">
                        <blockquote className="flex flex-col items-center">
                        <img className="p-2 w-48 h-48  rounded-lg -rotate-12" src="/images/first2.png" alt="" />
                            <p className="text-lg font-normal text-left">
                                This diaper, brought back from a mission trip to Haiti, was given to us to use as a pattern.
                            </p> 
                        </blockquote>
                    </div>
                </figure>
            </div>
            <div className="mb-4 w-full lg:w-1/2 h-full">
                <figure className="h-full w-full  shadow-lg md:flex bg-slate-100 rounded-xl p-8 md:p-0 ">
                    <div className="p-2 pt-10 text-center md:text-left space-y-4">
                        <blockquote className="flex flex-col items-center">
                        <img className="p-2 w-48 h-48 rounded-lg mx-auto rotate-12" src="/images/ourfirst.png" alt="" />
                           <p className="text-lg font-normal text-left">
                            Using the original diaper from Haiti, this is the first diaper we made out of t-shirts.
                            </p>
                        </blockquote>
                    </div>
                </figure>
            </div>
        </div>
        {/* <div className="frame-row">
            <div className="mgd-box">
                <div className="matte">
                    <div className="text-frame">
                        <img width="220" className="first" src="/images/first2.png" />
                    </div>
                    <p>
                        This is the original diaper brought back from a mission trip to Haiti. The Missionaries of Charity Sisters gave it to us to use as a pattern.                         </p>
                </div>
            </div>
            <div>
                <div className="matte">
                    <div className="text-frame">
                        <img width="180" className="second" src="/images/ourfirst.png?1" />
                    </div>
                    <p>
                        Using the original diaper from Haiti, this is the first diaper we made.
                    </p>
                </div>
            </div>
        </div> */}

    </div>
}
